import { useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import axios from "axios";
import config from "../configure";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function getToken(code) {  
  var redirect_url
  if (window.location.host === 'localhost:3000') {
    redirect_url = 'http://' + window.location.host + '/callback';
  } else  {
    redirect_url = 'https://' + window.location.host + '/callback';
  }  

  return axios.get(`${config.API_URL}/token?code=${code}&redirect_uri=${redirect_url}`)
    .then(res => {
      localStorage.setItem('token', res.data.token)
      localStorage.setItem('student_id', res.data.student_id)
  }).catch( (err) =>{
    localStorage.clear()
    return (err)
  })  
}

export default function Callback() {
  useEffect(() => {
    getToken(query.get("code"))
      .then(() => history.push('/AcademicResult'))
      .catch( reason => {
        console.log('reason : ', reason)
      })
   
  });

  let history = useHistory();
  let query = useQuery();
  return null;
}
